import PropTypes from 'prop-types'
import React from 'react'

import * as t from '@rushplay/theme'
import * as icons from '@rushplay/icons'
import styled from '@emotion/styled'
import { Flex, Link, Space, Text } from '@rushplay/common'
import { useI18n } from '@rushplay/i18n'

import { HtmlContent } from '../html-content'

const Promo = styled(Flex)`
  max-width: 700px;
  min-height: 45px;
  border-radius: 4px;
  box-shadow: ${t.boxShadow(0)};
  background-color: ${t.color('white')};
  align-items: center;

  ${t.mediaQuery.sm`
    width: auto;
  `};
`

const Chevron = styled(Flex)`
  color: ${t.color('primary')};
`

export function PromoText(props) {
  const i18n = useI18n()

  return (
    <Flex justifyContent="center">
      <Space paddingBottom="16px">
        <Link target="_self" to={i18n.translate(props.link)}>
          <Promo>
            <Flex flex-grow={2} justifyContent="center">
              <Space padding="16px">
                <Text textAlign="left" fontWeight="600" lineHeight={1.3}>
                  <HtmlContent
                    html={{
                      __html: i18n.translate(props.text),
                    }}
                  />
                </Text>
              </Space>
            </Flex>
            <Space>
              <Chevron justifyContent="center">
                <Space paddingRight="16px">
                  <icons.IconWrapper>
                    <icons.IconChevronRight />
                  </icons.IconWrapper>
                </Space>
              </Chevron>
            </Space>
          </Promo>
        </Link>
      </Space>
    </Flex>
  )
}

PromoText.propTypes = {
  text: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
}
